// dropdown.js
document.addEventListener("DOMContentLoaded", function () {
  const toggleBtn = document.querySelector(".dropdown-toggle");
  const dropdownMenu = document.querySelector(".dropdown-menu");

  if (toggleBtn && dropdownMenu) {
    toggleBtn.addEventListener("click", toggleMenu);
  }

  function toggleMenu() {
    dropdownMenu.classList.toggle("active-menu");
  }

  // Закрытие меню при клике вне его
  document.addEventListener("click", function (event) {
    if (
      !dropdownMenu.contains(event.target) &&
      !toggleBtn.contains(event.target)
    ) {
      dropdownMenu.classList.remove("active-menu");
    }
  });
});
